import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Umbrella, HardHat, Building2 } from "lucide-react";

const BADGES = [
  {
    icon: ShieldCheck,
    title: "CHAS Accredited",
    sub: "Contractor Health & Safety scheme",
  },
  {
    icon: Umbrella,
    title: "Fully Insured",
    sub: "Public Liability cover",
  },
  {
    icon: HardHat,
    title: "H&S Compliant",
    sub: "Site safety first, always",
  },
  {
    icon: Building2,
    title: "Commercial & Residential",
    sub: "Experience across London",
  },
];

export default function Accreditations() {
  return (
    <section
      id="accreditations"
      data-testid="accreditations-section"
      className="bg-[#F5EFE5] text-[#2B2420] py-20 md:py-24 border-y border-[#E5DDD0]"
    >
      <div className="px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#B8732C] mb-5 font-bold">
            <span className="brand-gold-divider" /> Accreditations & Insurance
          </div>
          <h2
            className="font-black tracking-tighter leading-[0.95] text-3xl md:text-4xl lg:text-5xl"
            style={{ fontFamily: "Cabinet Grotesk" }}
          >
            Safe hands. <br /> Fully covered.
          </h2>
          <p className="mt-5 text-[#4D4037] leading-relaxed max-w-md">
            We operate to high health &amp; safety standards and are fully
            insured for commercial and residential projects across London.
          </p>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {BADGES.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={b.title}
                data-testid={`accreditation-${i}`}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.45, delay: i * 0.06 }}
                className="bg-white border border-[#E5DDD0] p-5 md:p-6 text-center lift-hover"
              >
                <div className="w-11 h-11 mx-auto bg-[#2B2420] text-[#C9A24C] flex items-center justify-center">
                  <Icon className="w-5 h-5" strokeWidth={1.75} />
                </div>
                <div
                  className="mt-4 font-black text-base md:text-lg leading-tight"
                  style={{ fontFamily: "Cabinet Grotesk" }}
                >
                  {b.title}
                </div>
                <div className="mt-1 text-[11px] md:text-xs text-[#8A7F74] leading-snug">
                  {b.sub}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
